import React, { SetStateAction, createContext, useState } from "react";
import { ActionItem } from "schemas/dashboard";

interface ActionItemsContextInterface {
  actionItems: ActionItem[];
  setActionItems: React.Dispatch<SetStateAction<ActionItem[]>>;
  updateActionItems: (completedActionItemIds: number[]) => void;
}

const defaultContextMissingFunction = () => {
  throw new Error("context is missing");
};

const defaultInterface = {
  actionItems: [],
  setActionItems: defaultContextMissingFunction,
  updateActionItems: defaultContextMissingFunction,
};

const ActionItemsContext =
  createContext<ActionItemsContextInterface>(defaultInterface);

interface ActionItemsProviderProps {
  children: React.ReactNode;
}

const ActionItemsProvider = ({ children }: ActionItemsProviderProps) => {
  const [actionItems, setActionItems] = useState<ActionItem[]>([]);

  const updateActionItems = (completedActionItemIds: number[]) => {
    setActionItems((prevActionItems) =>
      prevActionItems?.filter((x) => !completedActionItemIds.includes(x.id)),
    );
  };

  return (
    <ActionItemsContext.Provider
      value={{
        actionItems,
        setActionItems,
        updateActionItems,
      }}
    >
      {children}
    </ActionItemsContext.Provider>
  );
};

export { ActionItemsProvider, ActionItemsContext };
